export default "__VITE_ASSET__DGCuhEj$__"